import React from "react";
import { Card, Spin } from "antd";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

const CrescimentoBaseChartV2 = ({ data, loading }) => (
  <Card style={{ marginBottom: 24 }}>
    <h3 style={{ marginBottom: 16 }}>Crescimento da Base (Alunos e Matrículas)</h3>
    {loading ? (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
        <Spin size="large" />
      </div>
    ) : (
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data} margin={{ top: 16, right: 24, left: 0, bottom: 0 }}>
          <XAxis dataKey="competencia" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey="total_alunos" name="Alunos" stroke="#1890ff" strokeWidth={2} />
          <Line type="monotone" dataKey="total_matriculas" name="Matrículas" stroke="#52c41a" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    )}
  </Card>
);

export default CrescimentoBaseChartV2;
